import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=4a310428&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=4a310428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a310428",
  null
  
)

export default component.exports